import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { MultiEditorComponent } from './multi-editor.component';

const multiEditorRoutes: Routes = [
  { path: '', component: MultiEditorComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(multiEditorRoutes)
  ],
  exports: [RouterModule]
})
export class MultiEditorRouter { }



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/app/multi-editor/multi-editor.router.ts